import { render, staticRenderFns } from "./SuccessForm.vue?vue&type=template&id=065efda4"
import script from "./SuccessForm.vue?vue&type=script&lang=js"
export * from "./SuccessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports